import React from "react";
import { Routes, Route } from "react-router-dom";

import Home from "./Home";
import Features from "./Features";
import About from "./About";
import Resources from "./Resources";
import Contact from "./Contact";

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/features" element={<Features />} />
      <Route path="/about" element={<About />} />
      <Route path="/resources" element={<Resources />} />
      <Route path="/contact" element={<Contact />} />
    </Routes>
  );
}